import { lazy } from 'react';
import { EnumBehaviorKey } from 'src/types/Behaviors';
import { AppRoute } from 'src/types/Route';

const ListUser = lazy(
  () =>
    import(
      /* webpackChunkName: "ListUser" */ 'src/pages/Backstage/subPages/UserPermission/ListUser'
    ),
);

const ListRole = lazy(
  () =>
    import(
      /* webpackChunkName: "ListRole" */ 'src/pages/Backstage/subPages/UserPermission/ListRole'
    ),
);

const UserPermissionRoutes: AppRoute[] = [
  {
    name: '用户列表',
    path: '/backstage/user-permission/list-user',
    Component: ListUser,
    behaviors: [EnumBehaviorKey.BASE_DATA_MAINTENANCE],
  },
  {
    name: '角色列表',
    path: '/backstage/user-permission/list-role',
    Component: ListRole,
    behaviors: [EnumBehaviorKey.BASE_DATA_MAINTENANCE],
  },
];

export default UserPermissionRoutes;
